// Same as loader-globals.ts except includes rrweb scripts.

import './loader-recorder'
import { init_from_snippet } from './posthog-core'

init_from_snippet()
